var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarIconGreenXxl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "car_icon_green_XXL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car_icon_green_XXL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck-cargo",
    transform: "translate(1.000000, 6.000000)",
    fill: "#95C11F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875,20 C20.1525,20 18.75,18.5975 18.75,16.875 C18.75,15.1525 20.1525,13.75 21.875,13.75 C23.5975,13.75 25,15.1525 25,16.875 C25,18.5975 23.5975,20 21.875,20 Z M21.875,15 C20.84125,15 20,15.84125 20,16.875 C20,17.90875 20.84125,18.75 21.875,18.75 C22.90875,18.75 23.75,17.90875 23.75,16.875 C23.75,15.84125 22.90875,15 21.875,15 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625,20 C3.90125,20 2.5,18.5975 2.5,16.875 C2.5,15.1525 3.90125,13.75 5.625,13.75 C7.34875,13.75 8.75,15.1525 8.75,16.875 C8.75,18.5975 7.34875,20 5.625,20 Z M5.625,15 C4.59125,15 3.75,15.84125 3.75,16.875 C3.75,17.90875 4.59125,18.75 5.625,18.75 C6.65875,18.75 7.5,17.90875 7.5,16.875 C7.5,15.84125 6.65875,15 5.625,15 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,17.5 C10.905,17.5 10.625,17.22 10.625,16.875 C10.625,16.53 10.905,16.25 11.25,16.25 L16.875,16.25 C17.22,16.25 17.5,16.53 17.5,16.875 C17.5,17.22 17.22,17.5 16.875,17.5 L11.25,17.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.875,17.5 C26.53,17.5 26.25,17.22 26.25,16.875 C26.25,16.53 26.53,16.25 26.875,16.25 L28.125,16.25 C28.47,16.25 28.75,15.97 28.75,15.625 L28.75,11.3975 C28.75,11.16 28.6175,10.945 28.40375,10.83875 L25.4775,9.375 L18.75,9.375 L18.75,13.75 C18.75,14.095 18.47,14.375 18.125,14.375 C17.78,14.375 17.5,14.095 17.5,13.75 L17.5,12.5 L1.25,12.5 L1.25,14.375 C1.25,14.72 0.97,15 0.625,15 C0.28,15 0,14.72 0,14.375 L0,1.875 C0,0.84125 0.84125,0 1.875,0 L22.5,0 C24.2225,0 25.625,1.40125 25.625,3.125 L25.625,3.75 C25.625,4.16625 25.4225,4.53875 25.09625,4.7675 C25.155,4.8775 25.2,4.99125 25.23375,5.10875 L26.15,8.31375 L28.9625,9.72125 C29.6025,10.04 30,10.6825 30,11.39625 L30,15.625 C30,16.65875 29.15875,17.5 28.125,17.5 L26.875,17.5 Z M17.5,11.25 L17.5,1.25 L1.875,1.25 C1.53,1.25 1.25,1.53 1.25,1.875 L1.25,11.25 L17.5,11.25 Z M24.79625,8.125 L24.0325,5.4525 C23.95625,5.18625 23.71,5 23.4325,5 L18.75,5 L18.75,8.125 L24.79625,8.125 Z M24.375,3.75 L24.375,3.125 C24.375,2.09125 23.53375,1.25 22.5,1.25 L18.75,1.25 L18.75,3.75 L24.375,3.75 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIconGreenXxl);
export default __webpack_public_path__ + "static/media/car_icon_green_XXL.6253e982eae94509a4503944fd119fcb.svg";
export { ForwardRef as ReactComponent };